import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_2: FaireProductEntity = {
  token: "legacy_prod_abbott-2",
  type: "product",
  name: "Green LED Pillar Candle 2x4 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7ee9b3406a3d67eb82e05469ab77cad131f6c8e441800f9e852929ca863fe442.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
